import axios, { AxiosResponse } from "axios";
import "./AxiosInterceptor";


export const BASE_URL = "http://140.238.225.86:9191/" // Replace with your actual base URL

interface QueryParams {
    [key: string]: string | number | boolean | null | undefined
}

interface HttpRequestOptions {
    path: string
    queryParams?: QueryParams | null
    body?: any
}

// Function to convert object to query parameters
const toQueryParams = (queryParams: QueryParams): string => {
    if (!queryParams || Object.keys(queryParams).length === 0) {
        throw new Error("Query parameters cannot be empty")
    }
    return new URLSearchParams(queryParams as Record<string, string>).toString()
}

// HTTP GET Request
export const httpGet = async ({ path, queryParams = null }: HttpRequestOptions): Promise<AxiosResponse<any>> => {
    if (queryParams) {
        path = `${path}?${toQueryParams(queryParams)}`
    }

    try {
        const response = await axios.get(`${BASE_URL}${path}`)
        return response
    } catch (error: any) {
        console.error(error.message)
        throw new Error(error.message)
    }
}

// HTTP POST Request
export const httpPost = async ({ path, queryParams = null, body = null }: HttpRequestOptions): Promise<AxiosResponse<any>> => {
    if (queryParams) {
        path = `${path}?${toQueryParams(queryParams)}`
    }

    try {
        const response = await axios.post(`${BASE_URL}${path}`, body)
        return response;
    } catch (error: any) {
        console.error(error)
        throw error;
    }
}